module.exports = __webpack_public_path__ + "media/img/super-venue/myaccount-a2aa6653862b9a42d5a46ff448ca841e.png";